import { ALERT, MSG } from '../model/msg/equip';
import { getEquipSettingTpl } from './../model/tpl/equip';
import { isDefined, isObject, not, truthy, falsy, notSingleEle, allOf, anyOf, each, getDefined, parseInt10, parseStrIntToInt, numberWithCommas, isWarrior, getClassName, removeEquipInEquips, getDivideIntStrByThousandUnit } from '../../../utils/util';
import { handleApiError } from '../../../utils/service';
import { API_DOMAIN_DEFAULT } from '../../../model/model';
import { getItemStatisticSummary, getAffectStats } from '../utils/service';
import EquipModel from './EquipModel';
import SingletonLoading from './../utils/SingletonLoading';
import EquipPriceLayer from './EquipPriceLayer';

class EquipSetting {
  constructor(options) {
    const _ = this;

    if (not(isDefined)(options)) {
      throw new Error('EquipSetting constructor require options object');
    }

    _.option = $.extend({
      wrap: null,
      apiDomain: API_DOMAIN_DEFAULT,
      searchApiDomain: API_DOMAIN_DEFAULT,
      data: null,
      global: window
    }, options);

    _.model = EquipModel.getInstance();

    _.loading = SingletonLoading.getInstance();

    _.wrap = null;

    _.data = _.option.data;
    /*
     {
     page, // 'default', 'view', 'modify'
     statType, // 'my' or 'setting'
     serverId,
     serverName,
     classId,
     characterName,
     level,
     hp,
     mp,
     stats, // {mainStat:{itemAffectedStat, mainStat}, subStat, formattedSubStat}
     expandSlots, // {isEarringSlot, isInsigniaSlot, isLeftRingSlot, isRightRingSlot, isShoulderSlot}
     equipItems, // [{enchant, itemId, itemName, slot}
     // changedStats,
     isEditable, // true, false
     memo: '',
     idx: ''
     }
     */

    // nodes
    _.sword_0 = null;
    _.sword_1 = null;
    _.headpiece_0 = null;
    _.t_shirt_0 = null;
    _.armor_0 = null;
    _.cloak_0 = null;
    _.gloves_0 = null;
    _.gaiter_0 = null;
    _.shield_0 = null;
    _.guard_0 = null;
    _.shoulder_0 = null; // expand shoulder slot
    _.emblem_0 = null; // expand emblem slot. api data name is insignia.
    _.necklace_0 = null;
    _.pendant_0 = null; //201908
    _.belt_0 = null;
    _.ring_0 = null;
    _.ring_1 = null;
    _.ring_2 = null; // expand left ring slot
    _.ring_3 = null; // expand right ring slot
    _.ring_4 = null; // add expand left ring slot
    _.ring_5 = null; // add expand right ring slot
    _.earring_0 = null;
    _.earring_1 = null; // expand earring slot
    _.boots_0 = null;
    _.relic_0 = null;
    _.crest_0 = null;

    // instances
    _.equipPriceLayer = null;

    _.displayTotalPrice = null;

    // datas
    _.equipLists = [];

    _.savedEquipListsStatusArr = [];
    _.savedTotalPrice = 0;

    _.wearEquips = [];
    _.rings = [];
    _.earrings = [];

    _.isExpandShoulderSlot = true; // shoulder_0 slot expand true/false
    _.isExpandInsigniaSlot = true; // emblem_0 slot expand true/false. api data name is insignia
    _.isExpandLeftRingSlot = true; // ring_2 slot expand true/false
    _.isExpandRightRingSlot = true; // ring_3 slot expand true/false
    _.isAddExpandLeftRingSlot = true; // ring_4 slot add expand true/false
    _.isAddExpandRightRingSlot = true; // ring_5 slot add expand true/false

    _.isExpandEarringSlot = true; // earring_1 slot expand true/false

    _.isEquipSettingVisible = true;

    _.global = _.option.global;
  }

  init() {
    const _ = this;
    _.wrap = $(_.option.wrap);

    if (notSingleEle(_.wrap)) throw new Error('EquipSetting wrap must be single element.');

    _.setInstance();

    return _;
  }

  setInstance() {
    const _ = this;

    const equipSettingTplFunc = doT.template(getEquipSettingTpl()),
      equipTpl = equipSettingTplFunc(_.data);

    _.wrap.append(equipTpl);

    // equip nodes
    _.sword_0 = $('#sword_0', _.wrap);
    _.sword_1 = $('#sword_1', _.wrap);
    _.headpiece_0 = $('#headpiece_0', _.wrap);
    _.t_shirt_0 = $('#t_shirt_0', _.wrap);
    _.armor_0 = $('#armor_0', _.wrap);
    _.cloak_0 = $('#cloak_0', _.wrap);
    _.gloves_0 = $('#gloves_0', _.wrap);
    _.gaiter_0 = $('#gaiter_0', _.wrap);
    _.shield_0 = $('#shield_0', _.wrap);
    _.guard_0 = $('#guard_0', _.wrap);
    _.shoulder_0 = $('#shoulder_0', _.wrap); // expand shoulder slot
    _.emblem_0 = $('#emblem_0', _.wrap); // expand emblem slot. api data name is insignia.
    _.necklace_0 = $('#necklace_0', _.wrap);
    _.pendant_0 = $('#pendant_0', _.wrap); //201908
    _.belt_0 = $('#belt_0', _.wrap);
    _.ring_0 = $('#ring_0', _.wrap);
    _.ring_1 = $('#ring_1', _.wrap);
    _.ring_2 = $('#ring_2', _.wrap); // expand left ring slot
    _.ring_3 = $('#ring_3', _.wrap); // expand right ring slot
    _.ring_4 = $('#ring_4', _.wrap); // add expand left ring slot
    _.ring_5 = $('#ring_5', _.wrap); // add expand right ring slot
    _.earring_0 = $('#earring_0', _.wrap);
    _.earring_1 = $('#earring_1', _.wrap); // expand earring slot
    _.boots_0 = $('#boots_0', _.wrap);
    _.relic_0 = $('#relic_0', _.wrap);
    _.crest_0 = $('#crest_0', _.wrap);

    _.equipLists = [
      _.sword_0, _.sword_1, _.headpiece_0, _.t_shirt_0, _.armor_0, _.cloak_0, _.gloves_0, _.gaiter_0, _.shield_0, _.guard_0, _.shoulder_0, _.emblem_0, _.necklace_0, _.pendant_0, _.belt_0, _.ring_0, _.ring_1, _.ring_2, _.ring_3, _.ring_4, _.ring_5, _.earring_0, _.earring_1, _.boots_0, _.relic_0, _.crest_0
    ]; //201908

    _.savedEquipListsStatusArr = [];
    _.savedTotalPrice = 0;

    // set total price
    _.displayTotalPrice = $('.totalprice strong', _.wrap);

    // set status of equip nodes
    each(_.equipLists, ($list) => _.setListContents($list, null));

    // warrior can equip 2 swords. but, other jobs can equip 1 swords.
    ( isWarrior(_.data.classId) ) ? _.sword_1.show() : _.sword_1.hide();

    // set btn's eventHandler in equip nodes
    _.setSearchBtnsEventHandler(true);
    _.setListIconsEventHandler(true);
    _.setListResetBtnsEventHandler(true);

    // set able/disable expand slots
    if (falsy(_.isExpandShoulderSlot)) _.disableResetAndSearchBtn(_.shoulder_0);
    if (falsy(_.isExpandInsigniaSlot)) _.disableResetAndSearchBtn(_.emblem_0);
    if (falsy(_.isExpandLeftRingSlot)) _.disableResetAndSearchBtn(_.ring_2);
    if (falsy(_.isExpandRightRingSlot)) _.disableResetAndSearchBtn(_.ring_3);
    if (falsy(_.isAddExpandLeftRingSlot)) _.disableResetAndSearchBtn(_.ring_4);
    if (falsy(_.isAddExpandRightRingSlot)) _.disableResetAndSearchBtn(_.ring_5);
    if (falsy(_.isExpandEarringSlot)) _.disableResetAndSearchBtn(_.earring_1);

    switch (_.data.page) {
      case 'default':
        // none
        break;

      case 'view':
        _.showAllResetAndSearchBtns(false);
        break;

      case 'modify':
        // none
        break;
    }

    _.setEquipTotalPrice('0');

    _.setEquipPriceLayer();
  }

  setEquipPriceLayer() {
    const _ = this;

    _.equipPriceLayer = new EquipPriceLayer().init();

    $(_.equipPriceLayer).on(EquipPriceLayer.EVT_CLOSE, function (evt) {
      _.equipPriceLayer.show(false);

      $(_).trigger({
        type: EquipSetting.DISPLAY_AFFECT_STATS,
        stats: []
      });
    });
  }

  showAllResetAndSearchBtns(flag) {
    if (truthy(flag)) {
      $('.btn-reset').show();
      $('.btn-search').show();

    } else {
      $('.btn-reset').hide();
      $('.btn-search').hide();
    }
  }

  setSearchBtnsEventHandler(flag) {
    const _ = this;

    if (truthy(flag)) {
      each(_.equipLists, function ($list) {
        $('.btn-search', $list).off('click.searchbtn').on('click.searchbtn', function (evt) {
          evt.preventDefault();

          const list = $(this).closest('li');

          $(_).trigger({
            type: EquipSetting.SHOW_ITEM_SEARCH_LAYER,
            slotId: list.attr('id'),
            slotName: $('.item-name input', list).attr('data-equip_type') // 2022.01 반지 슬롯 업데이트, 반지 (100 Lv) 형태로 표기하기 위해서  placeholder -> data-equip_type
          });
        });
      });

    } else {
      each(_.equipLists, function ($list) {
        $('.btn-search', $list).off('click.searchbtn');
      });
    }
  }

  setListIconsEventHandler(flag) {
    const _ = this;

    if (truthy(flag)) {
      each(_.equipLists, function ($list) {
        $('.item-icon', $list).off('click.icon').on('click.icon', function (evt) {
          const $this = $(this);

          const $list = $this.data('list');
          if (not(isDefined)($list)) return;

          const equipItemObj = $list.data('item');
          if (isDefined(equipItemObj)) {
            console.log('equipItemObj :', equipItemObj);

            if (truthy(_.loading.isLoading)) return;
            _.loading.start();

            let equipmentIds = '';
            each(_.data.equipItems, (equipItemObj) => equipmentIds += `,${equipItemObj.itemId}`);
            equipmentIds = equipmentIds.substr(1);

            (async function () {
              try {
                let price = await getItemStatisticSummary({
                  apiDomain: _.option.apiDomain,
                  searchApiDomain: _.option.searchApiDomain,
                  sendData: {
                    serverId: parseInt10(_.data.serverId),
                    itemId: parseInt10(equipItemObj.itemId),
                    enchant: parseInt10(equipItemObj.enchant)
                  }
                });
                console.log('price :', price);

                let affectStats = await getAffectStats({
                  apiDomain: _.option.apiDomain,
                  searchApiDomain: _.option.searchApiDomain,
                  itemId: equipItemObj.itemId,
                  enchant: equipItemObj.enchant,
                  sendData: {
                    classId: _.data.classId,
                    equipmentIds: equipmentIds // 304,16989,16103,97,1288, ...
                  }
                });
                console.log('affectStats :', affectStats);

                _.loading.end();

                _.equipPriceLayer.setPrice(price.marketPriceSummary.itemPriceSummary.lowestPrice, price.marketPriceSummary.itemStatisticSummary.averagePrice);
                _.equipPriceLayer.appendTo($this);
                _.equipPriceLayer.show(true);

                $(_).trigger({
                  type: EquipSetting.DISPLAY_AFFECT_STATS,
                  stats: affectStats.list || []
                });

              } catch (error) {
                _.loading.end();

                if (falsy(handleApiError(error.jqXHR))) _.global.alert(ALERT.FAIL_LOAD_ITEM_PRICE); // '장비 시세 정보를 가져올 수 없습니다. 잠시 후, 다시 시도해주세요.'
              }
            }());
          }
        });
      });

    } else {
      each(_.equipLists, ($list) => $('.item-icon', $list).off('click.icon'));
    }
  }

  setListResetBtnsEventHandler(flag) {
    const _ = this;

    if (truthy(flag)) {
      each(_.equipLists, function ($list) {
        $('.btn-reset', $list).off('click.resetbtn').on('click.resetbtn', function (evt) {
          evt.preventDefault();

          let list = $(this).data('list');

          if (isDefined(list)) {
            const itemObj = list.data('item');

            if (not(isDefined)(itemObj)) return;
            console.log('itemObj :', itemObj);

            const equips = removeEquipInEquips(_.wearEquips, itemObj);
            console.log('equips after removeEquipInEquips() :', equips);

            $(_).trigger({
              type: EquipSetting.RESET_ONE_LIST,
              wearEquips: equips,
              list: list,
              itemObj: itemObj
            });
          }
        });
      });

    } else {
      each(_.equipLists, ($list) => $('.btn-reset', $list).off('click.resetbtn'));
    }
  }

  setEquipTotalPriceByEquips() {
    console.log('call setEquipTotalPriceByEquips()');

    this.setEquipTotalPrice(String(this.getEquipTotalPriceByEquips()));
  }

  getEquipTotalPriceByEquips() {
    const _ = this;

    let price = 0, equip;
    for (let i = 0, max = _.wearEquips.length; i < max; i++) {
      equip = _.wearEquips[i];
      console.log('equip :', equip);
      console.log('equip.price :', equip.price);

      if (isDefined(equip)) price += parseStrIntToInt(equip.price || 0);
    }

    return price;
  }

  setEquipTotalPrice(intStr = '0') {
    const _ = this;

    console.log('intStr :', intStr);

    let unitValues = getDivideIntStrByThousandUnit(intStr);
    unitValues.reverse();

    let priceStr = '';
    for (let i = 0, max = unitValues.length; i < max; i++) {
      priceStr = (numberWithCommas(unitValues[i]) + _.model.PRICE_UINTS[i]) + priceStr;

      if (i !== unitValues.length) priceStr = ' ' + priceStr;
    }

    _.displayTotalPrice.text(priceStr);
  }

  setEquipTotalPriceStr(str = '') {
    this.displayTotalPrice.text(String(str));
  }

  addEquipItem(equipItemObj) {
    console.log('addEquipItem - equipItemObj :', equipItemObj);

    const _ = this;

    let itemObj = null;
    for (let i = 0, max = _.wearEquips.length; i < max; i++) {
      itemObj = _.wearEquips[i];

      if (allOf(isDefined(itemObj), itemObj.slot === equipItemObj.slot)) {
        _.removeEquipItem(itemObj);
        break;
      }
    }
    console.log('addEquipItem() before - _.wearEquips :', _.wearEquips);
    console.log('addEquipItem() before - _.rings :', _.rings);
    console.log('addEquipItem() before - _.earrings :', _.earrings);

    _.wearEquips.push(equipItemObj);

    const slotName = equipItemObj.slot;
    if (anyOf(slotName === 'ring_0', slotName === 'ring_1', slotName === 'ring_2', slotName === 'ring_3', slotName === 'ring_4', slotName === 'ring_5')) _.rings.push(equipItemObj);
    if (anyOf(slotName === 'earring_0', slotName === 'earring_1')) _.earrings.push(equipItemObj);

    console.log('addEquipItem() after - _.wearEquips :', _.wearEquips);
    console.log('addEquipItem() after - _.rings :', _.rings);
    console.log('addEquipItem() after - _.earrings :', _.earrings);
  }

  removeEquipItem(equipItemObj) {
    const _ = this;

    _.wearEquips = removeEquipInEquips(_.wearEquips, equipItemObj);
    _.rings = removeEquipInEquips(_.rings, equipItemObj);
    _.earrings = removeEquipInEquips(_.earrings, equipItemObj);

    console.log('_.wearEquips :', _.wearEquips);
    console.log('_.rings :', _.rings);
    console.log('_.earrings :', _.earrings);
  }

  setListContents($list, equipItemObj = null) {
    const _ = this;

    if (anyOf(not(isDefined)($list), $list.length <= 0)) return;

    if (isDefined(equipItemObj)) {
      $list.addClass('diff');

      $list.data('item', equipItemObj);

      const imgUrl = equipItemObj.itemImageUrl || '';
      if(imgUrl !== '') {
        $('.item-icon img', $list).attr('src', equipItemObj.itemImageUrl).show();

      } else {
        $('.item-icon img', $list).attr('src', '').hide();
      }

      const title = (parseInt10(equipItemObj.enchant) >= 0) ? `+${equipItemObj.enchant} ${equipItemObj.itemName}` : `-${equipItemObj.enchant} ${equipItemObj.itemName}`;
      $('.item-name input', $list).val(title);

    } else {
      $list.removeClass('diff');

      $list.data('item', null);

      $('.item-icon img', $list).attr('src', '').hide();

      $('.item-name input', $list).val('');
    }

    _.setResetAndSearchBtnByListHasEquipItem($list);
  }

  disableResetAndSearchBtn($list) {
    if (anyOf(not(isDefined)($list), $list.length <= 0)) return;

    $list.addClass('disabled'); // no use

    $('.item-icon img', $list).attr('src', '').hide();

    $('.item-name input', $list).val('');

    $('.btn-reset', $list).hide();
    $('.btn-search', $list).hide();
  }

  updateEquipsBtnInfoAndBtnReset() {
    const _ = this;

    each(_.equipLists, ($list) => {
      $('.item-icon', $list).data('list', $list);
      $('.btn-reset', $list).data('list', $list);
    });
  }

  /*
   * public
   */
  isListHasEquipItem($list) {
    if (anyOf(notSingleEle($list), $('.item-name input', $list).val().trim() === '')) return false;

    return true;
  }

  isShieldOrGuardHasEquipItem() {
    const _ = this;

    if (anyOf(_.isListHasEquipItem(_.shield_0), _.isListHasEquipItem(_.guard_0))) return true;

    return false;
  }

  setResetAndSearchBtnByListHasEquipItem($list) {
    if (anyOf(not(isDefined)($list), $list.length <= 0)) return;

    const resetBtn = $('.btn-reset', $list),
      searchBtn = $('.btn-search', $list);

    if (truthy(this.isListHasEquipItem($list))) {
      resetBtn.show();
      searchBtn.hide();

    } else {
      resetBtn.hide();
      searchBtn.show();
    }
  }

  setListUsable($list) {
    if (anyOf(not(isDefined)($list), $list.length <= 0)) return;

    this.setResetAndSearchBtnByListHasEquipItem($list);

    $list.removeClass('disabled'); // no use
  }

  getSwordEquipByStyle(listName, equipStyle) {
    const _ = this;

    let equipItemObj = null;
    for (let i = 0, max = _.wearEquips.length; i < max; i++) {
      equipItemObj = _.wearEquips[i];

      if (allOf(equipItemObj.slot === listName, equipItemObj.style === equipStyle)) return equipItemObj;
    }

    return null;
  }

  getSwordEquipByType(listName, equipType) {
    const _ = this;

    let equipItemObj = null;
    for (let i = 0, max = _.wearEquips.length; i < max; i++) {
      equipItemObj = _.wearEquips[i];

      if (allOf(equipItemObj.slot === listName, equipItemObj.type === equipType)) return equipItemObj;
    }

    return null;
  }

  checkWearableEarring(itemObj) {
    const _ = this;

    if (anyOf(itemObj.slot === 'earring_0', itemObj.slot === 'earring_1')) {
      let isWearableMoreEqualEarring = true;

      let obj = null;
      for (let i = 0, max = _.earrings.length; i < max; i++) {
        obj = _.earrings[i];

        if (obj.slot === itemObj.slot) continue; // 슬롯의 아이템 변경 시도이므로 체크에서 제외

        if (parseInt10(obj.itemId) === parseInt10(itemObj.itemId)) {
          isWearableMoreEqualEarring = false;
          break;
        }
      }

      if (falsy(isWearableMoreEqualEarring)) {
        return {
          result: false,
          msg: MSG.IMPOSSIBLE_WEAR_EQUAL_EARRING
        };
      }

      if (allOf(itemObj.slot === 'earring_1', falsy(_.isExpandEarringSlot))) {
        return {
          result: false,
          msg: MSG.IMPOSSIBLE_WEAR_EXPAND_EARRING_SLOT
        };
      }

      return {result: true};
    }

    return {
      result: false,
      msg: ''
    };
  }

  checkWearableRing(equipItemObj) {
    const _ = this;

    if (anyOf(equipItemObj.slot === 'ring_0', equipItemObj.slot === 'ring_1', equipItemObj.slot === 'ring_2', equipItemObj.slot === 'ring_3', equipItemObj.slot === 'ring_4', equipItemObj.slot === 'ring_5')) {
      let isWearableMoreEqualRing = true,
        isWearableMoreCashOrEventRing = true;

      console.log('equipItemObj :', equipItemObj);

      let cnt = 0;
      for (let i = 0, max = _.rings.length; i < max; i++) {
        let obj = _.rings[i];
        console.log('obj :', obj);

        if (obj.slot === equipItemObj.slot) continue; // 슬롯의 아이템 변경 시도이므로 체크에서 제외

        if (parseStrIntToInt(obj.itemId) === parseStrIntToInt(equipItemObj.itemId)) cnt++;

        if (cnt === 2) {
          // 같은 id의 반지는 2개를 초과하여 착용할 수 없다.
          console.log('can not equal id rings');

          isWearableMoreEqualRing = false;
          break;
        }
      }

      if (falsy(isWearableMoreEqualRing)) {
        console.log('isWearableMoreEqualRing === false');

        return {
          result: false,
          msg: MSG.IMPOSSIBLE_WEAR_EQUAL_RING
        };
      }

      // event or cash 반지 착용 시도
      if (anyOf(truthy(equipItemObj.cashItem), truthy(equipItemObj.eventItem))) { // 2022.01 isCashItem -> cashItem, isEventItem -> eventItem
        cnt = 0;
        for (let j = 0, len = _.rings.length; j < len; j++) {
          let ringObj = _.rings[j];

          console.log('ringObj :', ringObj);

          if (ringObj.slot === equipItemObj.slot) continue; // 슬롯의 아이템 변경 시도이므로 체크에서 제외

          if (ringObj.cashItem === true || ringObj.eventItem === true) cnt++; // 2022.01 isCashItem -> cashItem, isEventItem -> eventItem

          if (cnt === 2) {
            // 이벤트 or 유료 반지는 2개를 초과하여 착용할 수 없다.
            isWearableMoreCashOrEventRing = false;
            break;
          }
        }

        if (falsy(isWearableMoreCashOrEventRing)) {
          return {
            result: false,
            msg: MSG.IMPOSSIBLE_WEAR_MORE_EVENT_OR_CASH_RING
          };
        }
      }

      if (allOf(equipItemObj.slot === 'ring_2', falsy(_.isExpandLeftRingSlot))) {
        return {
          result: false,
          msg: MSG.IMPOSSIBLE_WEAR_EXPAND_RING_SLOT
        };
      }

      if (allOf(equipItemObj.slot === 'ring_3', falsy(_.isExpandRightRingSlot))) {
        return {
          result: false,
          msg: MSG.IMPOSSIBLE_WEAR_EXPAND_RING_SLOT
        };
      }

      if (allOf(equipItemObj.slot === 'ring_4', falsy(_.isAddExpandRightRingSlot))) {
        return {
          result: false,
          msg: MSG.IMPOSSIBLE_WEAR_EXPAND_RING_SLOT
        };
      }

      if (allOf(equipItemObj.slot === 'ring_5', falsy(_.isAddExpandRightRingSlot))) {
        return {
          result: false,
          msg: MSG.IMPOSSIBLE_WEAR_EXPAND_RING_SLOT
        };
      }

      return {result: true};
    }

    return {
      result: false,
      msg: ''
    };
  }

  wearItemAndGetResult(itemObj = {
    itemId: '',
    enchant: 0,
    price: 0,
    itemName: '',
    slot: '',
    style: '',
    cashItem: false, // 2022.01 isCashItem -> cashItem
    eventItem: false, // 2022.01  isEventItem -> eventItem
    itemImageUrl: ''

  }, isNotWearItemAndReturnResultOnly = false) {
    const _ = this,
      model = _.model;

    if (itemObj.type === model.SWORD_STYLE.ARROW) {
      return {
        result: false,
        msg: MSG.IMPOSSIBLE_WEAR_ARROW // '장비 슬롯에 착용할 수 없는 아이템입니다.' // '화살' 착용 불가.
      };
    }

    if (isWarrior(_.data.classId)) {
      // 전사
      const isExistSword0 = _.isListHasEquipItem(_.sword_0),
        isExistSword1 = _.isListHasEquipItem(_.sword_1),
        isTwoHandSword0 = _.getSwordEquipByStyle('sword_0', model.SWORD_STYLE.TWOHAND),
        isTwoHandSword1 = _.getSwordEquipByStyle('sword_1', model.SWORD_STYLE.TWOHAND),
        isBluntSword0 = _.getSwordEquipByType('sword_0', model.SWORD_TYPE.BLUNT),
        isBluntSword1 = _.getSwordEquipByType('sword_1', model.SWORD_TYPE.BLUNT);

      if (itemObj.slot === 'sword_0') {
        // 창
        if (itemObj.type === model.SWORD_TYPE.SPEAR) {
          if (isExistSword1) {
            //sword_1 에 둔기가 장착되어 있다면
            console.log(MSG.IMPOSSIBLE_WEAR_SPEAR_WHEN_EXIST_SECOND_SWORD);

            return {
              result: false,
              msg: MSG.IMPOSSIBLE_WEAR_SPEAR_WHEN_EXIST_SECOND_SWORD // '창은 쌍수로 착용이 불가합니다.' // 슬롯 2에 무기를 착용하고 있을 때는, 슬롯 1에 창 착용 불가. - 창은 쌍수로 착용이 불가합니다.
            };

          } else {
            //sword_1 에 둔기가 장착되어 있지 않다면
            if (itemObj.style === model.SWORD_STYLE.TWOHAND) { // 양손 창 착용 시도
              if (_.isListHasEquipItem(_.shield_0)) { // 이미 방패가 착용되어져 있는 상태라면
                console.log(MSG.IMPOSSIBLE_WEAR_TWOHAND_SWORD_WHEN_WEAR_SHIELD);

                return {
                  result: false,
                  msg: MSG.IMPOSSIBLE_WEAR_TWOHAND_SWORD_WHEN_WEAR_SHIELD // '양손 무기와 방패는 동시에 착용이 불가합니다.' // 방패 착용시에는, 양손 무기나 양손 창의 착용 불가.
                };
              }

              // 방패가 착용되지 않은 상태라면
              if (isNotWearItemAndReturnResultOnly) {
                return {result: true};
              }

              _.disableResetAndSearchBtn(_.shield_0);
              _.disableResetAndSearchBtn(_.sword_1);
              _.setListContents(_.sword_0, itemObj);
              _.addEquipItem(itemObj);
              _.setEquipTotalPriceByEquips();

              return {result: true};
            }

            // sword_1에 둔기가 장착되어 있지 않고, 한손 창이라면
            if (isNotWearItemAndReturnResultOnly) return {result: true};
            _.disableResetAndSearchBtn(_.sword_1);
            _.setListUsable(_.shield_0);
            _.setListContents(_.sword_0, itemObj);
            _.addEquipItem(itemObj);
            _.setEquipTotalPriceByEquips();
            return {result: true};
          }
        }

        // 창 이외 무기
        if (itemObj.style === model.SWORD_STYLE.TWOHAND) { // 양손 무기 착용 시도
          if (_.isListHasEquipItem(_.shield_0)) { // 이미 방패가 착용되어져 있는 상태라면
            console.log(MSG.IMPOSSIBLE_WEAR_TWOHAND_SWORD_WHEN_WEAR_SHIELD);
            return {
              result: false,
              msg: MSG.IMPOSSIBLE_WEAR_TWOHAND_SWORD_WHEN_WEAR_SHIELD // 방패 착용시에는, 양손 무기나 양손 창의 착용 불가
            };
          }

          // 방패가 착용되지 않은 상태
          if (isExistSword1) { // sword_1 에 무기가 착용된 상태라면
            console.log(MSG.IMPOSSIBLE_WEAR_TWOHAND_WHEN_EXIST_SECOND_SWORD);
            return {
              result: false,
              msg: MSG.IMPOSSIBLE_WEAR_TWOHAND_WHEN_EXIST_SECOND_SWORD // 슬롯 2에 무기 착용하고 있을 때는, 슬롯 1에 양손 무기 착용 불가
            };
          }

          //sword_1 에 둔기가 장착되어 있지 않다면
          if (isNotWearItemAndReturnResultOnly) return {result: true};
          _.disableResetAndSearchBtn(_.shield_0);
          _.disableResetAndSearchBtn(_.sword_1);
          _.setListContents(_.sword_0, itemObj);
          _.addEquipItem(itemObj);
          _.setEquipTotalPriceByEquips();
          return {result: true};

        } else if (itemObj.style === model.SWORD_STYLE.ONEHAND) { // 한손 무기 착용 시도
          // 한손 무기이자 둔기
          if (itemObj.type === model.SWORD_TYPE.BLUNT) {
            // sword_1에 둔기가 이미 장착되어 있다면
            if (isBluntSword1) {
              // 방패나 가더가 장착되어져 있다면
              if (_.isListHasEquipItem(_.shield_0) || _.isListHasEquipItem(_.guard_0)) {
                console.log(MSG.IMPOSSIBLE_WEAR_DOUBLE_ONEHAND_WHEN_WEAR_SHIELD_OR_GUARD); // complete
                return {
                  result: false,
                  msg: MSG.IMPOSSIBLE_WEAR_DOUBLE_ONEHAND_WHEN_WEAR_SHIELD_OR_GUARD // 방패나 가더 착용시에는 쌍수 불가
                };
              }

              // 방패나 가더가 장착되어 있지 않다면, 쌍수 가능.
              if (isNotWearItemAndReturnResultOnly) return {result: true};
              _.disableResetAndSearchBtn(_.shield_0);
              _.disableResetAndSearchBtn(_.guard_0);
              _.setListContents(_.sword_0, itemObj);
              _.addEquipItem(itemObj);
              _.setEquipTotalPriceByEquips();
              return {result: true};
            }

            // sword_1에 장착된 둔기가 없다면, sword_0에 한손 둔기만 착용.
            if (isNotWearItemAndReturnResultOnly) return {result: true};
            _.setListUsable(_.sword_1);
            _.setListUsable(_.shield_0);
            _.setListContents(_.sword_0, itemObj);
            _.addEquipItem(itemObj);
            _.setEquipTotalPriceByEquips();
            return {result: true};
          }

          // 한손 무기이자 둔기가 아닐 경우
          if (isBluntSword1) {
            // sword_1 에 둔기가 이미 장착되어 있다면
            return {
              result: false,
              msg: MSG.IMPOSSIBLE_WEAR_NOT_BLUNT_WHEN_BLUNT_IN_SECOND_SWORD // 슬롯 2에 둔기 장착 상태에서, 슬롯 1에 둔기가 아닌 무기를 장착할 때.
            };
          }

          // sword_0에 둔기가 아닌 무기 착용시, sword_1 사용 불가.
          if (isNotWearItemAndReturnResultOnly) return {result: true};
          _.setListContents(_.sword_0, itemObj);
          _.disableResetAndSearchBtn(_.sword_1);
          _.addEquipItem(itemObj);
          _.setEquipTotalPriceByEquips();
          return {result: true};
        }
      } else if (itemObj.slot === 'sword_1') {
        if (itemObj.style === model.SWORD_STYLE.TWOHAND) { // 양손 무기 착용 시도
          console.log(MSG.IMPOSSIBLE_MUST_WEAR_ONEHAND_IN_SECOND_SWORD_SLOT);
          return {
            result: false,
            msg: MSG.IMPOSSIBLE_MUST_WEAR_ONEHAND_IN_SECOND_SWORD_SLOT // 슬롯 2에는 한손 무기만 착용 가능. - 한손 무기만 착용 가능.
          };
        }

        // 한손 무기 착용 시도
        if (itemObj.type !== model.SWORD_TYPE.BLUNT) { // 둔기가 아닐 경우
          console.log(MSG.IMPOSSIBLE_MUST_BLUNT_IN_SECOND_SWORD); // complete
          return {
            result: false,
            msg: MSG.IMPOSSIBLE_MUST_BLUNT_IN_SECOND_SWORD // 슬롯 2에는 둔기만 착용 가능. - 둔기만 쌍수로 착용 가능.
          };
        }

        // 한손 둔기 착용 시도
        if (truthy(isExistSword0)) { // sword_0에 이미 무기가 착용되어 있는 경우
          if (falsy(isBluntSword0)) { // sword_0에 둔기가 아닌 무기가 착용되어 있을 경우
            console.log(MSG.IMPOSSIBLE_WEAR_BLUNT_WHEN_NOT_BLUNT_IN_FIRST_SWORD);
            return {
              result: false,
              msg: MSG.IMPOSSIBLE_WEAR_BLUNT_WHEN_NOT_BLUNT_IN_FIRST_SWORD // 슬롯 1이 둔기가 아님. 슬롯 2는 둔기 착용 시도
            };
          }

          // sword_0에 이미 한손 둔기가 착용되어 있는 경우

          if (anyOf(_.isListHasEquipItem(_.shield_0), _.isListHasEquipItem(_.guard_0))) { // 방패나 가더가 장착되어져 있다면
            console.log(MSG.IMPOSSIBLE_WEAR_DOUBLE_ONEHAND_WHEN_WEAR_SHIELD_OR_GUARD);
            return {
              result: false,
              msg: MSG.IMPOSSIBLE_WEAR_DOUBLE_ONEHAND_WHEN_WEAR_SHIELD_OR_GUARD // 방패나 가더 착용시에는 쌍수 불가
            };
          }

          // 방패나 가더가 장착되어 있지 않다면, 쌍수 가능.
          if (isNotWearItemAndReturnResultOnly) return {result: true};
          _.disableResetAndSearchBtn(_.shield_0);
          _.disableResetAndSearchBtn(_.guard_0);
          _.setListContents(_.sword_1, itemObj);
          _.addEquipItem(itemObj);
          _.setEquipTotalPriceByEquips();
          return {result: true};
        }

        // sword_0 에 무기 착용되어 있지 않은 경우
        if (isNotWearItemAndReturnResultOnly) return {result: true};

        _.setListContents(_.sword_1, itemObj);
        _.addEquipItem(itemObj);
        _.setEquipTotalPriceByEquips();

        return {result: true};
      }

    } else {
      // 전사 외

      // - 무기
      if (itemObj.slot === 'sword_0') {
        console.log('전사 외. 무기 장착 시도');

        if (itemObj.style === model.SWORD_STYLE.TWOHAND) { //양손 무기 장착 시도
          console.log('전사 외. 양손 무기 장착 시도');

          if (_.isListHasEquipItem(_.shield_0)) { // 이미 방패가 착용되어져 있는 상태라면
            return {
              result: false,
              msg: MSG.IMPOSSIBLE_WEAR_TWOHAND_SWORD_WHEN_WEAR_SHIELD // 방패 착용시에는, 양손 무기나 양손 창의 착용 불가
            };
          }

          // 방패가 착용되어 있지 않다면
          if (truthy(isNotWearItemAndReturnResultOnly)) {
            return {result: true};
          }

          _.disableResetAndSearchBtn(_.shield_0);
          _.setListContents(_.sword_0, itemObj);
          _.addEquipItem(itemObj);
          _.setEquipTotalPriceByEquips();

          return {result: true};
        }

        // 한손 무기 장착 시도
        if (truthy(isNotWearItemAndReturnResultOnly)) {
          return {result: true};
        }

        _.setListUsable(_.shield_0);

        _.setListContents(_.sword_0, itemObj);
        _.addEquipItem(itemObj);
        _.setEquipTotalPriceByEquips();

        return {result: true};
      }
    }

    if (itemObj.slot === 'headpiece_0') {
      if (isNotWearItemAndReturnResultOnly) return {result: true};
      _.setListContents(_.headpiece_0, itemObj);
      _.addEquipItem(itemObj);
      _.setEquipTotalPriceByEquips();

      return {result: true};
    }

    if (itemObj.slot === 't_shirt_0') {
      if (isNotWearItemAndReturnResultOnly) return {result: true};
      _.setListContents(_.t_shirt_0, itemObj);
      _.addEquipItem(itemObj);
      _.setEquipTotalPriceByEquips();

      return {result: true};
    }

    if (itemObj.slot === 'armor_0') {
      if (isNotWearItemAndReturnResultOnly) return {result: true};
      _.setListContents(_.armor_0, itemObj);
      _.addEquipItem(itemObj);
      _.setEquipTotalPriceByEquips();

      return {result: true};
    }

    if (itemObj.slot === 'cloak_0') {
      if (isNotWearItemAndReturnResultOnly) return {result: true};
      _.setListContents(_.cloak_0, itemObj);
      _.addEquipItem(itemObj);
      _.setEquipTotalPriceByEquips();

      return {result: true};
    }

    if (itemObj.slot === 'glove_0' || itemObj.slot === 'gloves_0') {
      if (isNotWearItemAndReturnResultOnly) return {result: true};
      _.setListContents(_.gloves_0, itemObj);
      _.addEquipItem(itemObj);
      _.setEquipTotalPriceByEquips();

      return {result: true};
    }

    if (itemObj.slot === 'gaiter_0') {
      if (isNotWearItemAndReturnResultOnly) return {result: true};
      _.setListContents(_.gaiter_0, itemObj);
      _.addEquipItem(itemObj);
      _.setEquipTotalPriceByEquips();

      return {result: true};
    }

    if (itemObj.slot === 'shield_0') {
      if (_.isListHasEquipItem(_.guard_0)) {
        console.log(MSG.IMPOSSIBLE_WEAR_SHIELD_WHEN_EXIST_GUARD);

        return {
          result: false,
          msg: MSG.IMPOSSIBLE_WEAR_SHIELD_WHEN_EXIST_GUARD
        };
      }

      if (isNotWearItemAndReturnResultOnly) return {result: true};
      _.setListContents(_.shield_0, itemObj);
      _.addEquipItem(itemObj);
      _.setEquipTotalPriceByEquips();
      _.disableResetAndSearchBtn(_.guard_0);

      return {result: true};
    }

    if (itemObj.slot === 'guard_0') {
      if (_.isListHasEquipItem(_.shield_0)) {
        console.log(MSG.IMPOSSIBLE_WEAR_GUARD_WHEN_EXIST_SHIELD);

        return {
          result: false,
          msg: MSG.IMPOSSIBLE_WEAR_GUARD_WHEN_EXIST_SHIELD
        };
      }

      if (isNotWearItemAndReturnResultOnly) return {result: true};
      _.setListContents(_.guard_0, itemObj);
      _.addEquipItem(itemObj);
      _.setEquipTotalPriceByEquips();
      _.disableResetAndSearchBtn(_.shield_0);

      return {result: true};
    }

    // ADD (s) - 20161219
    if (itemObj.slot === 'shoulder_0') {
      if (isNotWearItemAndReturnResultOnly) return {result: true};
      _.setListContents(_.shoulder_0, itemObj);
      _.addEquipItem(itemObj);
      _.setEquipTotalPriceByEquips();

      return {result: true};
    }

    if (itemObj.slot === 'emblem_0') {
      if (isNotWearItemAndReturnResultOnly) return {result: true};
      _.setListContents(_.emblem_0, itemObj);
      _.addEquipItem(itemObj);
      _.setEquipTotalPriceByEquips();

      return {result: true};
    }
    // ADD (e) - 20161219

    if (itemObj.slot === 'necklace_0') {
      if (isNotWearItemAndReturnResultOnly) return {result: true};
      _.setListContents(_.necklace_0, itemObj);
      _.addEquipItem(itemObj);
      _.setEquipTotalPriceByEquips();

      return {result: true};
    }

    if (itemObj.slot === 'pendant_0') {
      if (isNotWearItemAndReturnResultOnly) return {result: true};
      _.setListContents(_.pendant_0, itemObj);
      _.addEquipItem(itemObj);
      _.setEquipTotalPriceByEquips();

      return {result: true};
    } //201908

    if (itemObj.slot === 'belt_0') {
      if (isNotWearItemAndReturnResultOnly) return {result: true};
      _.setListContents(_.belt_0, itemObj);
      _.addEquipItem(itemObj);
      _.setEquipTotalPriceByEquips();

      return {result: true};
    }

    if (anyOf(itemObj.slot === 'ring_0', itemObj.slot === 'ring_1', itemObj.slot === 'ring_2', itemObj.slot === 'ring_3', itemObj.slot === 'ring_4', itemObj.slot === 'ring_5')) {
      const resultObj = _.checkWearableRing(itemObj);

      if (resultObj.result === true) {
        if (isNotWearItemAndReturnResultOnly) return {result: true};
        _.setListContents(_[itemObj.slot], itemObj);
        _.addEquipItem(itemObj);
        _.setEquipTotalPriceByEquips();

        return {result: true};
      } else {
        return resultObj;
      }
    }

    if (itemObj.slot === 'earring_0' || itemObj.slot === 'earring_1') {
      const resultObject = _.checkWearableEarring(itemObj);

      if (resultObject.result === true) {
        if (isNotWearItemAndReturnResultOnly) return {result: true};
        _.setListContents(_[itemObj.slot], itemObj);
        _.addEquipItem(itemObj);
        _.setEquipTotalPriceByEquips();

        return {result: true};
      } else {
        return resultObject;
      }
    }

    if (itemObj.slot === 'boots_0') {
      if (isNotWearItemAndReturnResultOnly) return {result: true};
      _.setListContents(_.boots_0, itemObj);
      _.addEquipItem(itemObj);
      _.setEquipTotalPriceByEquips();

      return {result: true};
    }

    // REPAIR - 20160328
    if (itemObj.slot === 'relic_0') {
      if (isNotWearItemAndReturnResultOnly) return {result: true};
      _.setListContents(_.relic_0, itemObj);
      _.addEquipItem(itemObj);
      _.setEquipTotalPriceByEquips();

      return {result: true};
    }

    if (itemObj.slot === 'crest_0') {
      if (isNotWearItemAndReturnResultOnly) return {result: true};
      _.setListContents(_.crest_0, itemObj);
      _.addEquipItem(itemObj);
      _.setEquipTotalPriceByEquips();

      return {result: true};
    }

    return {result: true};
  }

  getEquips() {
    const _ = this;

    return {
      wearEquips: _.wearEquips || [],
      rings: _.rings || [],
      earrings: _.earrings || []
    };
  }

  resetOneListContents($list) {
    const _ = this;

    if (anyOf(not(isDefined)($list), $list.length <= 0)) return;

    $list.removeClass('diff');

    $list.data('item', null);

    $('.item-icon img', $list).attr('src', '').hide();

    $('.item-name input', $list).val('');

    _.setListUsable($list);
  }

  resetOneList($list, itemObj) {
    console.log('resetOneList - itemObj :', itemObj);

    const _ = this;

    if (anyOf(not(isDefined)($list), $list.length <= 0)) return;

    _.resetOneListContents($list);
    _.removeEquipItem(itemObj);

    _.setEquipTotalPriceByEquips();

    // reset sword_0
    if (isWarrior(_.data.classId)) {
      // 전사
      if ($list === _.sword_0) {
        // sword_0 해제
        if (itemObj.style === _.model.SWORD_STYLE.TWOHAND) {
          console.log('양손 무기 해제');
          _.setListUsable(_.sword_1);

          if (falsy(_.isShieldOrGuardHasEquipItem())) _.setListUsable(_.shield_0); // complete

        } else {
          //one hand

          if (itemObj.type === _.model.SWORD_TYPE.BLUNT) {
            // 둔기
            console.log('둔기 해제');

            if (_.getSwordEquipByType('sword_1', _.model.SWORD_TYPE.BLUNT)) {
              // 쌍수
              console.log('쌍수 해제');

              _.setListUsable(_.shield_0);
              _.setListUsable(_.guard_0);

            } else {
              console.log('둔기만 해제');
            }

          } else {
            console.log('둔기 외 한손 무기(검, 창, ...) 해제');

            _.setListUsable(_.sword_1);
          }
        }

      } else if ($list === _.sword_1) {
        if (truthy(_.getSwordEquipByType('sword_0', _.model.SWORD_TYPE.BLUNT))) {
          // 쌍수
          console.log('쌍수 해제');

          _.setListUsable(_.shield_0);
          _.setListUsable(_.guard_0);

        } else {
          console.log('둔기만 해제');
        }
      }
    } else {
      // check shield usable
      if ($list === _.sword_0) {
        if (itemObj.style === _.model.SWORD_STYLE.TWOHAND) {
          console.log('전사 외 직업이 양손 무기 해제시, 방패 활성화');

          if (falsy(_.isShieldOrGuardHasEquipItem())) _.setListUsable(_.shield_0);
        }
      }
    }

    if ($list === _.shield_0) {
      _.resetOneListContents(_.guard_0);

    } else if ($list === _.guard_0) {
      if (falsy(_.getSwordEquipByStyle('sword_0', _.model.SWORD_STYLE.TWOHAND))) _.resetOneListContents(_.shield_0);
    }
  }

  saveCurrentAllStatus() {
    const _ = this;

    _.savedEquipListsStatusArr = [];

    let itemObj;
    each(_.equipLists, function (equipList) {
      itemObj = $.extend({itemId: ''}, equipList.data('item'));

      _.savedEquipListsStatusArr.push({
        listNode: equipList,
        itemObj: itemObj
      });
    });

    _.savedTotalPrice = _.getEquipTotalPriceByEquips();
  }

  restoreAllEquips() {
    const _ = this;

    let equips = [];
    each(_.savedEquipListsStatusArr, function (status) { // {listNode, itemObj}
      if (allOf(isDefined(status.itemObj.itemName), status.itemObj.itemName !== '')) equips.push(status.itemObj);
    });

    _.setData({
      expandSlots: null,
      itemList: equips
    });
  }

  wearItemNoCondition(itemObj) {
    const _ = this;

    const isNotDefined = not(isDefined);
    if (anyOf(isNotDefined(itemObj), isNotDefined(itemObj.slot))) return;

    let listNode = _[itemObj.slot];
    if (anyOf(itemObj.slot === 'glove_0', itemObj.slot === 'gloves_0')) listNode = _.gloves_0; // itemObj.slot value is 'glove_0' or 'gloves_0'.

    _.setListContents(listNode, itemObj);
    _.addEquipItem(itemObj);
    _.setEquipTotalPriceByEquips();
  }

  setData(data = {
    expandSlots: {
      isShoulderSlot: false,
      isInsigniaSlot: false,
      isLeftRingSlot: false,
      isRightRingSlot: false,
      isAddLeftRingSlot: false,
      isAddRightRingSlot: false,
      isEarringSlot: false
    },
    itemList: []
  }) {
    const _ = this,
      expandSlots = data.expandSlots || {};

    _.isExpandShoulderSlot = getDefined(expandSlots.isShoulderSlot, _.isExpandShoulderSlot);
    _.isExpandInsigniaSlot = getDefined(expandSlots.isInsigniaSlot, _.isExpandInsigniaSlot);
    _.isExpandLeftRingSlot = getDefined(expandSlots.isLeftRingSlot, _.isExpandLeftRingSlot);
    _.isExpandRightRingSlot = getDefined(expandSlots.isRightRingSlot, _.isExpandRightRingSlot);
    _.isAddExpandLeftRingSlot = getDefined(expandSlots.isAddLeftRingSlot, _.isAddExpandLeftRingSlot);
    _.isAddExpandRightRingSlot = getDefined(expandSlots.isAddRightRingSlot, _.isAddExpandRightRingSlot);
    _.isExpandEarringSlot = getDefined(expandSlots.isEarringSlot, _.isExpandEarringSlot);

    // reset internal datas
    _.wearEquips = [];
    _.rings = [];
    _.earrings = [];

    // empty all lists
    each(_.equipLists, ($list) => {
      _.setListContents($list, null);
      _.setListUsable($list);
    });

    _.setEquipTotalPrice('0');

    // set items
    if (allOf(Array.isArray(data.itemList), data.itemList.length > 0)) {
      each(data.itemList, (itemObj) => _.wearItemNoCondition(itemObj));
    }

    // set list data.
    // show/hide reset, search btn.
    each(_.equipLists, function (equipList) {
      $('.item-icon', equipList).data('list', equipList);
      $('.btn-reset', equipList).data('list', equipList);

      _.setResetAndSearchBtnByListHasEquipItem(equipList);
    });

    if (allOf(falsy(_.isListHasEquipItem(_.shoulder_0)), falsy(_.isExpandShoulderSlot))) _.disableResetAndSearchBtn(_.shoulder_0);
    if (allOf(falsy(_.isListHasEquipItem(_.emblem_0)), falsy(_.isExpandInsigniaSlot))) _.disableResetAndSearchBtn(_.emblem_0);
    if (allOf(falsy(_.isListHasEquipItem(_.ring_2)), falsy(_.isExpandLeftRingSlot))) _.disableResetAndSearchBtn(_.ring_2);
    if (allOf(falsy(_.isListHasEquipItem(_.ring_3)), falsy(_.isExpandRightRingSlot))) _.disableResetAndSearchBtn(_.ring_3);
    if (allOf(falsy(_.isListHasEquipItem(_.ring_4)), falsy(_.isAddExpandLeftRingSlot))) _.disableResetAndSearchBtn(_.ring_4);
    if (allOf(falsy(_.isListHasEquipItem(_.ring_5)), falsy(_.isAddExpandRightRingSlot))) _.disableResetAndSearchBtn(_.ring_5);
    if (allOf(falsy(_.isListHasEquipItem(_.earring_1)), falsy(_.isExpandEarringSlot))) _.disableResetAndSearchBtn(_.earring_1);

    // set job detail
    if (isWarrior(_.data.classId)) {
      console.log('EquipSetting - setData. warrior');

      _.sword_1.show();

      const isExistSword0 = _.isListHasEquipItem(_.sword_0),
        isExistSword1 = _.isListHasEquipItem(_.sword_1),
        isTwoHandSword0 = _.getSwordEquipByStyle('sword_0', _.model.SWORD_STYLE.TWOHAND),
        isTwoHandSword1 = _.getSwordEquipByStyle('sword_1', _.model.SWORD_STYLE.TWOHAND),
        isBluntSword0 = _.getSwordEquipByType('sword_0', _.model.SWORD_TYPE.BLUNT),
        isBluntSword1 = _.getSwordEquipByType('sword_1', _.model.SWORD_TYPE.BLUNT);

      if (anyOf(isExistSword0, isExistSword1)) {
        // 무기가 장착된 경우
        if (allOf(isExistSword0, isTwoHandSword0)) {
          // 무기 1 슬롯에 양손 무기가 장착된 경우
          _.disableResetAndSearchBtn(_.sword_1);
          _.disableResetAndSearchBtn(_.shield_0);

          _.setListUsable(_.guard_0);

        } else {
          // 한손 or 쌍수

          if (allOf(isBluntSword0, isBluntSword1)) {
            // 무기 1, 2 슬롯 쌍수
            _.disableResetAndSearchBtn(_.shield_0);
            _.disableResetAndSearchBtn(_.guard_0);

          } else if (allOf(isExistSword0, !isExistSword1, isBluntSword0)) {
            // 무기 1 슬롯만 한손 무기 - 둔기

          } else if (allOf(isExistSword0, !isExistSword1, !isBluntSword0)) {
            // 무기 1 슬롯만 한손 무기 - 둔기가 아닌 경우
            _.disableResetAndSearchBtn(_.sword_1);

          } else if (allOf(!isExistSword0, isExistSword1, isBluntSword0)) {
            // 무기 2 슬롯에만 한손 무기 - 무기 2 슬롯에는 둔기만 장착 가능
          }
        }
      } else {
        // 무기가 장착되지 않은 경우
      }
    } else {
      console.log('EquipSetting - setData. not warrior');

      _.sword_1.hide();

      if (_.getSwordEquipByStyle('sword_0', _.model.SWORD_STYLE.ONEHAND)) {
        _.setListUsable(_.shield_0);
        _.setListUsable(_.guard_0);

      } else if (_.getSwordEquipByStyle('sword_0', _.model.SWORD_STYLE.TWOHAND)) {
        // when equip two handed sword, can not equip shield.
        _.disableResetAndSearchBtn(_.shield_0);
        _.setListUsable(_.guard_0);
      }
    }

    _.setSearchBtnsEventHandler(true);
    _.setListIconsEventHandler(true);
    _.setListResetBtnsEventHandler(true);

    if (isDefined(_.shield_0.data('item'))) {
      _.disableResetAndSearchBtn(_.guard_0);

    } else if (isDefined(_.guard_0.data('item'))) {
      _.disableResetAndSearchBtn(_.shield_0);
    }

    _.setEquipTotalPriceByEquips();
  }

  resetDiffAtAllEquips() {
    each(this.equipLists, ($list) => $list.removeClass('diff'));
  }

  resetDiffAtTotalPrice() {
    this.displayTotalPrice.removeClass('diff');
  }

  setDiffByCompareSavedEquipsAndNewEquips() {
    const _ = this;

    // check equip list difference
    let $list, itemObj, savedItemObj;
    for (var i = 0, max = _.equipLists.length; i < max; i++) {
      $list = _.equipLists[i];
      itemObj = $list.data('item');
      savedItemObj = _.savedEquipListsStatusArr[i];

      if (isDefined(itemObj)) {
        if (isDefined(savedItemObj)) {
          if (itemObj.itemId !== savedItemObj.itemObj.itemId) {
            // different
            $list.addClass('diff');
          }

        } else {
          // add
          $list.addClass('diff');
        }

      } else {
        $list.removeClass('diff');
      }
    }

    // check total price difference
    if (_.savedTotalPrice !== _.getEquipTotalPriceByEquips()) {
      _.displayTotalPrice.addClass('diff');

    } else {
      _.displayTotalPrice.removeClass('diff');
    }
  }

  showEquipSetting(flag) {
    const _ = this,
      equipSettingWrap = $('.simulating', _.wrap);

    if (truthy(flag)) {
      equipSettingWrap.show();

    } else {
      equipSettingWrap.hide();
    }

    _.isEquipSettingVisible = flag;
  }

  isShowEquipSetting() {
    return this.isEquipSettingVisible;
  }

  destroy(obj = null) {
    const _ = this;

    _.setSearchBtnsEventHandler(false);
    _.setListIconsEventHandler(false);
    _.setListResetBtnsEventHandler(false);

    if (isDefined(_.equipPriceLayer)) {
      _.equipPriceLayer.destroy();
      _.equipPriceLayer = null;
    }

    _.wearEquips = [];
    _.rings = [];
    _.earrings = [];

    _.isExpandShoulderSlot = false; // shoulder slot expand true/false
    _.isExpandInsigniaSlot = false; // insignia slot expand true/false
    _.isExpandLeftRingSlot = false; // ring_2 slot expand true/false
    _.isExpandRightRingSlot = false; // ring_3 slot expand true/false
    _.isAddExpandLeftRingSlot = false; // ring_4 slot expand true/false
    _.isAddExpandRightRingSlot = false; // ring_5 slot expand true/false
    _.isExpandEarringSlot = false; // earring_1 slot expand true/false

    _.savedEquipListsStatusArr = [];
    _.savedTotalPrice = 0;

    _.isEquipSettingVisible = true;
  }
}

EquipSetting.SHOW_ITEM_SEARCH_LAYER = 'SHOW_ITEM_SEARCH_LAYER';
EquipSetting.RESET_ONE_LIST = 'RESET_ONE_LIST';
EquipSetting.DISPLAY_AFFECT_STATS = 'DISPLAY_AFFECT_STATS';

export default EquipSetting;


// WEBPACK FOOTER //
// ./_src/js/world/characterSetting/equip/EquipSetting.js